import * as i0 from '@angular/core';
import { Component, Directive, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class EiptooltipComponent {
    constructor() { }
    ngOnInit() {
    }
    ngOnChanges() {
    }
}
EiptooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EiptooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EiptooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EiptooltipComponent, selector: "eiptooltip", usesOnChanges: true, ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EiptooltipComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'eiptooltip',
                    template: ``,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class EIPTooltipDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.eipTooltipWidth = '375';
        this.eipToolTipMinWidth = '100';
        this.delay = 0;
        this.offset = 10;
        this.mouseenterSubscription = this.renderer.listen(el.nativeElement, 'mouseenter', (event) => {
            if (this.tooltipTitle.length > 0 && !this.isMobileDevice) {
                this.eipTooltipPosition = this.locEipTooltipPosition;
                this.show(event);
            }
            this.mouseleaveSubscription = this.renderer.listen(el.nativeElement, 'mouseleave', (eventMouseleave) => {
                if (this.tooltip) {
                    this.hide();
                }
            });
            this.clickSubscription = this.renderer.listen(el.nativeElement, 'click', (eventClick) => {
                if (this.tooltip) {
                    this.hide();
                }
            });
            this.touchStartSubscription = this.renderer.listen(el.nativeElement, 'touchstart', (eventTouchstart) => {
                if (this.tooltipTitle.length > 0 && this.isMobileDevice) {
                    this.eipTooltipPosition = this.locEipTooltipPosition;
                    this.show(eventTouchstart);
                }
            });
            this.touchEndSubscription = this.renderer.listen(el.nativeElement, 'touchend', (eventTouchEnd) => {
                if (this.tooltip) {
                    this.hide();
                }
            });
        });
    }
    ngOnInit() {
        this.createElement();
        this.locEipTooltipPosition = this.eipTooltipPosition;
    }
    ngOnChanges(changes) {
        if (changes.tooltipTitle && this.tooltip) {
            this.tooltip.textContent = changes.tooltipTitle.currentValue;
        }
    }
    show(event) {
        if (this.tooltip !== null && this.tooltip.textContent) {
            this.renderer.addClass(this.tooltip, 'eip-tooltip-show');
            this.renderer.appendChild(document.body, this.tooltip);
            // this.setPosition(event);
            this.autoPlacement();
        }
    }
    hide() {
        if (this.tooltip !== null) {
            this.renderer.removeChild(document.body, this.tooltip);
            this.renderer.removeClass(this.tooltip, 'eip-tooltip-show');
        }
    }
    destroyElement() {
        this.renderer.removeChild(document.body, this.tooltip);
        this.tooltip = null;
    }
    createElement() {
        this.tooltip = this.renderer.createElement('span');
        this.renderer.appendChild(this.tooltip, this.renderer.createText(this.tooltipTitle) // textNode
        );
        this.renderer.setStyle(this.tooltip, 'max-width', `${this.eipTooltipWidth}px`);
        this.renderer.setStyle(this.tooltip, 'min-width', `${this.eipToolTipMinWidth}px`);
        this.renderer.addClass(this.tooltip, 'eip-tooltip');
        this.renderer.setStyle(this.tooltip, '-webkit-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-moz-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, '-o-transition', `opacity ${this.delay}ms`);
        this.renderer.setStyle(this.tooltip, 'transition', `opacity ${this.delay}ms`);
    }
    setPosition(event) {
        const hostPos = this.el.nativeElement.getBoundingClientRect();
        const tooltipPos = this.tooltip.getBoundingClientRect();
        const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        let top;
        let left;
        this.renderer.removeClass(this.tooltip, `eip-tooltip-${this.eipTooltipPosition}`);
        if (this.eipTooltipPosition === 'top') {
            top = hostPos.top - tooltipPos.height - this.offset;
            left = event.x - 50; // hostPos.left + (hostPos.width - tooltipPos.width) / 2;
            if (top < 0) {
                this.eipTooltipPosition = 'bottom';
            }
            if (this.tooltip.offsetWidth + event.x > window.innerWidth) {
                this.eipTooltipPosition = 'left';
            }
        }
        if (this.eipTooltipPosition === 'bottom') {
            top = hostPos.bottom + this.offset;
            left = event.x - 50; // hostPos.left + (hostPos.width - tooltipPos.width) / 2;
            if (this.tooltip.offsetHeight + event.y > window.innerHeight) {
                this.eipTooltipPosition = 'top';
                top = hostPos.top - tooltipPos.height - this.offset;
                left = event.x - 50;
            }
            if (this.tooltip.offsetWidth + event.x > window.innerWidth) {
                this.eipTooltipPosition = 'left';
            }
        }
        if (this.eipTooltipPosition === 'left') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = hostPos.left - tooltipPos.width - this.offset;
            if (left < 0) {
                this.eipTooltipPosition = 'right';
            }
            else if (event.x - this.tooltip.offsetWidth < 0) {
                this.eipTooltipPosition = 'right';
            }
        }
        if (this.eipTooltipPosition === 'right') {
            top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
            left = event.x + 30; // hostPos.right + this.offset;
            if (this.tooltip.offsetWidth + event.x > window.innerWidth) {
                this.eipTooltipPosition = 'left';
                top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
                left = hostPos.left - tooltipPos.width - this.offset;
            }
        }
        this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
        this.renderer.addClass(this.tooltip, `eip-tooltip-${this.eipTooltipPosition}`);
    }
    get isMobileDevice() {
        let isMobile = false;
        const mobiles = {
            Android: () => {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: () => {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: () => {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: () => {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: () => {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: () => {
                return (mobiles.Android() || mobiles.BlackBerry() || mobiles.iOS() || mobiles.Opera() || mobiles.Windows());
            }
        };
        if (mobiles.any()) {
            isMobile = true;
        }
        return isMobile;
    }
    getBoundingClientRect(element, includeScale) {
        const rect = element.getBoundingClientRect();
        const scaleX = 1;
        const scaleY = 1; // FIXME:
        // `offsetWidth` returns an integer while `getBoundingClientRect`
        // returns a float. This results in `scaleX` or `scaleY` being
        // non-1 when it should be for elements that aren't a full pixel in
        // width or height.
        // if (isHTMLElement(element) && includeScale) {
        //   const offsetHeight = element.offsetHeight;
        //   const offsetWidth = element.offsetWidth;
        //   // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        //   // Fallback to 1 in case both values are `0`
        //   if (offsetWidth > 0) {
        //     scaleX = rect.width / offsetWidth || 1;
        //   }
        //   if (offsetHeight > 0) {
        //     scaleY = rect.height / offsetHeight || 1;
        //   }
        // }
        return {
            width: rect.width / scaleX,
            height: rect.height / scaleY,
            top: rect.top / scaleY,
            right: rect.right / scaleX,
            bottom: rect.bottom / scaleY,
            left: rect.left / scaleX,
            x: rect.left / scaleX,
            y: rect.top / scaleY
        };
    }
    autoPlacement() {
        const positions = ['top', 'right', 'bottom', 'left'];
        for (const position of positions) {
            this.renderer.removeClass(this.tooltip, `eip-tooltip-${position}`);
        }
        const referenceClientRect = this.getBoundingClientRect(this.el.nativeElement);
        const popperOffsets = this.computeOffsets({
            reference: referenceClientRect,
            element: this.tooltip,
            placement: this.eipTooltipPosition
        });
        this.renderer.setStyle(this.tooltip, 'top', `${(popperOffsets.y)}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${popperOffsets.x}px`);
        this.renderer.addClass(this.tooltip, `eip-tooltip-${popperOffsets.position}`);
    }
    computeOffsets(ref) {
        const reference = ref.reference;
        const element = ref.element;
        const placement = ref.placement;
        let basePlacement = placement ? this.getBasePlacement(placement) : null;
        const variation = placement ? this.getVariationFromPlacement(placement) : null;
        const commonX = reference.x + reference.width / 2 - element.clientWidth / 2;
        const commonY = reference.y + reference.height / 2 - element.clientHeight / 2;
        let offsets;
        basePlacement = (reference.x - element.clientWidth) > 0 ? 'left' : 'right';
        if (this.isMobileDevice || window.innerWidth <= 575) {
            basePlacement = 'bottom';
        }
        switch (basePlacement) {
            case 'top':
                offsets = {
                    x: commonX,
                    y: reference.y - element.clientHeight
                };
                break;
            case 'bottom':
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                offsets = {
                    x: reference.x - element.clientWidth,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        const mainAxis = basePlacement ? this.getMainAxisFromPlacement(basePlacement) : null;
        if (mainAxis != null) {
            const len = mainAxis === 'y' ? 'height' : 'width';
            const elem = mainAxis === 'y' ? 'clientHeight' : 'clientWidth';
            switch (variation) {
                case 'start':
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[elem] / 2);
                    break;
                case 'end':
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[elem] / 2);
                    break;
            }
        }
        if ((this.isMobileDevice || window.innerWidth <= 575) && (basePlacement === 'top' || basePlacement === 'bottom')) {
            offsets.x = 0;
        }
        if (basePlacement === 'left' || basePlacement === 'right') {
            offsets.y += (element.clientHeight / 2) - 10;
        }
        offsets.position = basePlacement;
        return offsets;
    }
    getMainAxisFromPlacement(placement) {
        return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
    }
    getVariationFromPlacement(placement) {
        return ['top', 'bottom'].indexOf(placement) >= 0 ? 'start' : 'end';
    }
    getBasePlacement(placement) {
        return placement.split('-')[0];
    }
    // destroy the subscriptions
    ngOnDestroy() {
        if (this.mouseenterSubscription) {
            this.mouseenterSubscription();
        }
        this.hide();
        this.destroyElement();
    }
}
EIPTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
EIPTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: EIPTooltipDirective, selector: "[eipTooltip]", inputs: { tooltipTitle: ["eipTooltip", "tooltipTitle"], eipTooltipPosition: "eipTooltipPosition", eipTooltipWidth: "eipTooltipWidth", eipToolTipMinWidth: "eipToolTipMinWidth" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[eipTooltip]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { tooltipTitle: [{
                type: Input,
                args: ['eipTooltip']
            }], eipTooltipPosition: [{
                type: Input
            }], eipTooltipWidth: [{
                type: Input
            }], eipToolTipMinWidth: [{
                type: Input
            }] } });

// import { BrowserModule } from '@angular/platform-browser';
class EIPTooltipModule {
}
EIPTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipModule, declarations: [EiptooltipComponent, EIPTooltipDirective], imports: [CommonModule], exports: [EiptooltipComponent, EIPTooltipDirective] });
EIPTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipModule, imports: [[
            CommonModule,
            // BrowserModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EIPTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EiptooltipComponent, EIPTooltipDirective],
                    imports: [
                        CommonModule,
                        // BrowserModule
                    ],
                    exports: [EiptooltipComponent, EIPTooltipDirective]
                }]
        }] });

/*
 * Public API Surface of eip-tooltip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPTooltipDirective, EIPTooltipModule, EiptooltipComponent };
